"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), Object.defineProperty(exports, "ClientSettings", {
  enumerable: !0,
  get: function get() {
    return _clientSettings.ClientSettings;
  }
}), Object.defineProperty(exports, "ClientSettingsType", {
  enumerable: !0,
  get: function get() {
    return _types.ClientSettingsType;
  }
});
var _clientSettings = require("./clientSettings"),
  _types = require("./types");